import React, { useState, useEffect } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import { USER_PROFILE_PATH } from "../../Util/constant";
import { useTheme } from "../context/ThemeContext";
import { useSideBar } from "../context/SideBarContext";
import jwtDecode from "jwt-decode";
import { useProfile } from "../context/ProfileContext";
import NotificationDropdown from "./NotificationDropdown";
import ShareModel from "../components/modal/ShareModel";
import { copyToClipboard } from "../../Util/helper_functions";
import "../user-pages/userpages.css";
import { useHistory } from "react-router-dom";

//pass onSidebarToggle to manage while sidebar is icon only that time footer show perfectly
const Navbar = ({ onSidebarToggle }) => {
    const history = useHistory();
    const [showModal, setShowModal] = useState(false);
    const { isDarkTheme } = useTheme();
    const { profileData } = useProfile(); //use profile data using contex api
    const [selectedImage, setSelectedImage] = useState(null);


    const handleShow = () => setShowModal(true);
    // const handleHide = () => setShowModal(false);
    const handleHide = () => {
        //console.log("Befor Hide", showModal);
        setShowModal(false);
        if (showModal === "False") {
            console.log("After Hide", showModal);
        }
        //console.log("After Hide", showModal);
    };

    // Re-run the effect if profile data changes
    useEffect(() => {
        // Retrieve the access token from localStorage
        const token = localStorage.getItem("user_access_token");
        // If a token exists, decode it to get the user ID
        if (token) {
            const decodedToken = jwtDecode(token);
            const memberId = decodedToken.member_id;

            // Construct the image URL based on the memberId
            const imageUrl = `${USER_PROFILE_PATH}${memberId}.jpg?${new Date().getTime()}`;
            // Check if the constructed image URL is valid by sending a HEAD request
            fetch(imageUrl, { method: "HEAD" })
                .then((res) => {
                    // If the image exists, set it as the selected image
                    if (res.ok) {
                        setSelectedImage(imageUrl);
                    } else {
                        setSelectedImage(null); // No image found, show initials
                    }
                })
                .catch(() => {
                    setSelectedImage(null);
                });
        }
    }, [profileData]);



    const toggleOffcanvas = () => {
        document.querySelector(".sidebar-offcanvas").classList.toggle("active");
    };
    // Function for logout - remove ipo_access_token from local storage
    const logout = () => {
        localStorage.removeItem("user_access_token");
        localStorage.setItem("is_remember_on", "false");
        localStorage.removeItem("carousalModalShown"); // Remove the modal state from local storage
        history.push({
            pathname: "/login",
        });
    };
    // Function to get the capitalized first letter of the username
    const getInitials = (name) => {
        return name ? name.charAt(0).toUpperCase() : "";
    };

    return (
        <>
            <nav className="navbar p-0 fixed-top d-flex flex-row">
                <div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
                    <Link className="navbar-brand brand-logo-mini" to="/">
                        <img
                            src={require("../../assets/images/portal_mini.png")}
                            alt="logo"
                        />
                    </Link>
                </div>
                <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch justify-content-end no-padding">
                    <button
                        className="navbar-toggler align-self-center"
                        type="button"
                        onClick={() => onSidebarToggle()}
                    >
                        <span className="mdi mdi-menu "></span>
                    </button>
                    <ul className="navbar-nav navbar-nav-right">
                        <NotificationDropdown />

                        <Dropdown alignRight as="li" className="nav-item">
                            <Dropdown.Toggle
                                as="a"
                                className="nav-link cursor-pointer no-caret no-margin"
                            >
                                <div className="navbar-profile d-flex align-items-center">
                                    {/* Display profile image if available, otherwise show user first latter in a styled circle */}
                                    {selectedImage ? (
                                        <img
                                            src={selectedImage}
                                            alt="Profile"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                            }}
                                        />
                                    ) : (
                                        // Display  first latter  when profile image is unavailable
                                        <div
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                backgroundColor: "#ccc",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: "20px",
                                                color: "#fff",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {getInitials(profileData?.username)}
                                        </div>
                                    )}
                                    <p
                                        className="mb-0 navbar-profile-name profile-name"
                                        style={{ color: "#000000" }}
                                    >
                                        {/* Profile Name */}
                                        <Trans>{profileData?.username}</Trans>
                                    </p>
                                    <i className="mdi mdi-menu-down menu-icon"></i>
                                </div>
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                                className={`navbar-dropdown preview-list navbar-profile-dropdown-menu ${isDarkTheme && "dark-dropdown-menu"
                                    }`}
                            >
                                <Dropdown.Item as={Link} to="#" className="preview-item">
                                    <div className="preview-item-content mx-2 mt-1 mt-1">
                                        <p
                                            className="preview-subject mb-1"
                                            style={{
                                                whiteSpace: "pre-wrap",
                                                color: "#011638",
                                                lineHeight: "1.5",
                                                paddingLeft: "4px",
                                            }}
                                            onClick={() =>
                                                copyToClipboard(profileData?.user_registration_link)
                                            }
                                        //onClick={() => console.log(profileData.member_id)}
                                        >
                                            <Trans>
                                                User Info -{profileData?.username}(
                                                {profileData?.member_id})
                                            </Trans>
                                        </p>
                                    </div>
                                </Dropdown.Item>

                                <Dropdown.Item
                                    as={Link} // Using as to render Link instead of a div
                                    to={{
                                        pathname: "/profile/accountsettings",
                                        state: { selectedTab: "Account Setting" },
                                    }}
                                    className="preview-item"
                                    style={{ textDecoration: "none", color: "inherit" }} // Ensure text color and remove underline
                                >
                                    <div className="preview-thumbnail">
                                        <div className="preview-icon rounded-circle">
                                            <i
                                                className="mdi mdi-account-circle-outline"
                                                style={{ color: "#616F8C", fontSize: "20px" }}
                                            ></i>
                                        </div>
                                    </div>
                                    <div className="preview-item-content">
                                        <p
                                            className="preview-subject mb-1"
                                            style={{ whiteSpace: "pre-wrap", color: "#011638" }}
                                        >
                                            <Trans>Account Setting</Trans>
                                        </p>
                                    </div>
                                </Dropdown.Item>

                                <Dropdown.Item
                                    as={Link}
                                    to={{
                                        pathname: "/profile/accountsettings",
                                        state: { selectedTab: "User KYC" },
                                    }}
                                    className="preview-item"
                                    style={{ textDecoration: "none", color: "inherit" }}
                                >
                                    <div className="preview-thumbnail">
                                        <div className="preview-icon rounded-circle">
                                            <i
                                                className="mdi mdi-bank-outline"
                                                style={{ color: "#616F8C", fontSize: "20px" }}
                                            ></i>
                                        </div>
                                    </div>
                                    <div className="preview-item-content">
                                        <p
                                            className="preview-subject mb-1"
                                            style={{ whiteSpace: "pre-wrap", color: "#011638" }}
                                        >
                                            <Trans>User KYC</Trans>
                                        </p>
                                    </div>
                                </Dropdown.Item>

                                <Dropdown.Item
                                    as={Link}
                                    to={{
                                        pathname: "/profile/accountsettings",
                                        state: { selectedTab: "Security" },
                                    }}
                                    className="preview-item"
                                    style={{ textDecoration: "none", color: "inherit" }}
                                >
                                    <div className="preview-thumbnail">
                                        <div className="preview-icon rounded-circle">
                                            <i
                                                className="mdi mdi-security"
                                                style={{ color: "#616F8C", fontSize: "20px" }}
                                            ></i>
                                        </div>
                                    </div>
                                    <div className="preview-item-content">
                                        <p
                                            className="preview-subject mb-1"
                                            style={{ whiteSpace: "pre-wrap", color: "#011638" }}
                                        >
                                            <Trans>Security</Trans>
                                        </p>
                                    </div>
                                </Dropdown.Item>

                                <Dropdown.Item
                                    as={Link}
                                    to="/support"
                                    className="preview-item"
                                    style={{ textDecoration: "none", color: "inherit" }}
                                >
                                    <div className="preview-thumbnail">
                                        <div className="preview-icon rounded-circle">
                                            <i
                                                className="mdi mdi-web"
                                                style={{ color: "#616F8C", fontSize: "20px" }}
                                            ></i>
                                        </div>
                                    </div>
                                    <div className="preview-item-content">
                                        <p
                                            className="preview-subject mb-1"
                                            style={{ whiteSpace: "pre-wrap", color: "#011638" }}
                                        >
                                            <Trans>Support</Trans>
                                        </p>
                                    </div>
                                </Dropdown.Item>

                                <Dropdown.Item onClick={logout} className="preview-item">
                                    <div className="preview-thumbnail">
                                        <div className="preview-icon rounded-circle">
                                            <i
                                                className="mdi mdi-logout"
                                                style={{ color: "red", fontSize: "20px" }}
                                            ></i>
                                        </div>
                                    </div>
                                    <div className="preview-item-content">
                                        <p
                                            className="preview-subject mb-1"
                                            style={{ color: "red" }}
                                        >
                                            <Trans>Log Out</Trans>
                                        </p>
                                    </div>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Button
                            className="btn btn-primary text-white d-flex align-items-center align-self-center p-2"
                            onClick={(e) => {
                                e.preventDefault(); // Prevents default behavior
                                handleShow(); // Trigger the function for showing content
                            }}
                        >
                            Invite & Earn
                        </Button>
                    </ul>

                    <button
                        className="navbar-toggler navbar-toggler-right d-lg-none align-self-center p-2"
                        type="button"
                        onClick={toggleOffcanvas}
                    >
                        <span className="mdi mdi-format-line-spacing"></span>
                    </button>
                </div>
            </nav>

            {showModal && (
                <ShareModel
                    show={showModal}
                    onHide={handleHide}
                    shareUrl={profileData?.user_registration_link}
                    id={profileData?.member_id}
                />
            )}
        </>
    );
};

export default Navbar;
